import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { LinkButton } from 'app/components/core/LinkButton';

export function ShowDetailsButton({ i18nKey = null, onClick }) {
    const { t } = useTranslation();

    const label = i18nKey ? t(i18nKey) : t('components:NotificationHub.details');

    return <LinkButton onClick={onClick}>{label}</LinkButton>;
}

ShowDetailsButton.propTypes = {
    onClick: PropTypes.func.isRequired,
    i18nKey: PropTypes.string
};
